import React from 'react';

export const Legend = (props: { floorWifiSvgObject: any }) => {
  const { floorWifiSvgObject } = props;

  return (
    <div
      className="signal-legend"
      style={{ display: "-webkit-box", position: "absolute", right: 0, top: 0 }}
      dangerouslySetInnerHTML={{
        __html: floorWifiSvgObject.legend[0].innerHTML,
      }}
    ></div>
  );
};